import { render, staticRenderFns } from "./DeviceEditTabSettings.vue?vue&type=template&id=780d4887&"
import script from "./DeviceEditTabSettings.vue?vue&type=script&lang=js&"
export * from "./DeviceEditTabSettings.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports